module.exports = __webpack_public_path__ + "static/power2-2@2x-9ff77a9e1b0294eda746c9cdd47b273f.png";